class Hero extends BaseHero {
    constructSwiper() {
        this.swiper = new Swiper(this.swiperEl, {
            autoplay: {
                delay: 5000,
            },
            pagination: {
                el: '[data-hero-pagination]',
                clickable: true,
                type: 'fraction',
            },
            navigation: {
                nextEl: '[data-hero-next]',
                prevEl: '[data-hero-prev]',
            },
        });
    }
}